import { defineProfile } from "./define.js";

export const SALON_PROFILE = defineProfile("salon", {
  labels: ["contacts", "bookings", "services", "staff"],
  home: ["bookings_today", "no_shows", "unread_chats", "ai_handoffs"],
  kpis: ["bookings", "no_show_rate", "revenue", "conversations", "ai_handoffs"],
  panel: ["appointments", "past_services"],
  quickActions: ["book_appointment", "send_reminder"],
  contactFields: [
    { key: "preferred_staff", kind: "text", label: { ar: "الموظف المفضل", en: "Preferred staff" } },
  ],
  aiTools: ["search_kb", "lookup_availability", "book_slot", "escalate"],
  cloudStarterMenu: "appointments_menu",
  starterPack: "salon",
});
